<form [formGroup]="datiGeneraliForm" (ngSubmit)="save()" *ngIf="request">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <div class="row">
    <div class="col-sm-6">
      <p>
        <label for="ogg-disciplina-lbl">Oggetto</label>
        <input id="ogg-disciplina-lbl" class="form-control" type="text" disabled="" [value]="fascicolo && fascicolo.oggetto ? fascicolo.oggetto : null">
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <p>
        <label for="tip-contratto-lbl">Tipologia contratto</label>
        <input id="tip-contratto-lbl" class="form-control" type="text" disabled="" [value]="null">
      </p>
    </div>
    <!--<div comboModInput class="col-sm-4" [labelOption]="'nome'"
         [labelInput]="'Tipologia contratto'" formControlName="tipologiaContratto"
         [optionsCombo] ="soggettiOptions"
         [objectReference]="request.fascicolo.tipologiaContratto"
         [(ngModel)]="request.fascicolo.tipologiaContratto"
         (onReturn)="request.fascicolo.tipologiaContratto = $event;"
         [mandatory]="true"
         [submitPending] ="!datiGeneraliForm.controls['societa'].valid"
    ></div>-->

    <div class="col-sm-4">
      <p>
        <label for="tipologia-sanz-lbl">Tipologia sanzione</label>
        <input id="tipologia-sanz-lbl" class="form-control" type="text" disabled="" [value]="null">
      </p>
    </div>
    <!--<div comboModInput class="col-sm-4" [labelOption]="'nome'"
         [labelInput]="'Tipologia sanzione'" formControlName="tipologiaSanzione"
         [optionsCombo] ="soggettiOptions"
         [objectReference]="request.fascicolo.tipologiaSanzione"
         [(ngModel)]="request.fascicolo.tipologiaSanzione"
         (onReturn)="request.fascicolo.tipologiaSanzione = $event;"
         [mandatory]="true"
         [submitPending] ="!datiGeneraliForm.controls['tipologiaContratto'].valid"
    ></div>-->

    <div datePickerInput class="col-sm-4" [labelInput]="'Data provvedimento'"
         formControlName="dataProvvedimento"
         [control]="datiGeneraliForm.controls['dataProvvedimento']"
         [(ngModel)]="request.fascicolo.dataProvvedimento"
         [mandatory]="true"
    ></div>
    <!--[submitPending] ="!datiGeneraliForm.controls['tipologiaSanzione'].valid"-->

  </div>

  <div class="row">
    <!--<div singleCheckBoxModInput class="col-sm-4"
         [labelInput]="'Sospensione cautelare non disciplinare'" formControlName="sospensioneCautelareNonDisciplinare"
         [objectReference]="request.fascicolo.sospensioneCautelareNonDisciplinare"
         (onReturn)="request.fascicolo.sospensioneCautelareNonDisciplinare = $event"></div>-->
    <div checkBoxRadio class="col-sm-4"
         formControlName="sospensioneCautelareNonDisciplinare"
         idInput="sospensioneCautelareNonDisciplinare"
         [labelInput]="'Sospensione cautelare non disciplinare'"
         [objectReference]="request.fascicolo.sospensioneCautelareNonDisciplinare"
         (onReturn)="request.fascicolo.sospensioneCautelareNonDisciplinare = $event"></div>

    <!--<div singleCheckBoxModInput class="col-sm-4"
         [labelInput]="'Sospensione del rapporto di lavoro'" formControlName="sospensioneRapportoDiLavoro"
         [objectReference]="request.fascicolo.sospensioneRapportoDiLavoro"
         (onReturn)="request.fascicolo.sospensioneRapportoDiLavoro = $event"></div>-->
    <div checkBoxRadio class="col-sm-4"
         formControlName="sospensioneRapportoDiLavoro"
         idInput="sospensioneRapportoDiLavoro"
         [labelInput]="'Sospensione del rapporto di lavoro'"
         [objectReference]="request.fascicolo.sospensioneRapportoDiLavoro"
         (onReturn)="request.fascicolo.sospensioneRapportoDiLavoro = $event"></div>

    <!-- <div checkBoxRadio class="col-sm-4"
      [labelInput]="'Recupero crediti'" idInput="recupero_crediti"
      formControlName="recuperoCrediti" [objectReference]="request.fascicolo.recuperoCrediti"
      (onReturn)="request.fascicolo.recuperoCrediti = $event"></div> -->

  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
